




import Enumerable from "linq";
import { Mixins, Component, Prop } from "vue-property-decorator";
import { ModelEditableMixin, ModalPresentableMixin } from "../../../../../../base/components/system";
import { FormatPageStructureEditableMixin } from "../../mixins";
import {
  instanceOfIScriptGroupKeyPropertyEditable,
  instanceOfIRangeOfMotionGroupKeyPropertyEditable,
} from "../../../../../domain/editableFormat/properties";
import { default as ScriptGroupEditor } from "./ScriptGroupEditor.vue";
import { default as RangeOfMotionGroupEditor } from "./RangeOfMotionGroupEditor.vue";

@Component
export default class ObjectsRemover extends Mixins(ModelEditableMixin, ModalPresentableMixin, FormatPageStructureEditableMixin) {
  @Prop()
  scriptGroupEditor: ScriptGroupEditor;

  @Prop()
  rangeOfMotionGroupEditor: RangeOfMotionGroupEditor;

  async confirmAndRemove(): Promise<void> {
    const scriptGroupKeys = this.scriptGroupEditor.getSelectedGroupKeys();
    if (scriptGroupKeys.length > 0 && !await this.confirmScriptGroup()) {
      return;
    }
    const rangeOfMotionGroupIds = this.rangeOfMotionGroupEditor.getSelectedGroupIds();
    this.removeSelectedObjects(s =>
      (instanceOfIScriptGroupKeyPropertyEditable(s) && Enumerable.from(scriptGroupKeys).any(k => k === s.scriptGroupKey().getValue())) ||
      (instanceOfIRangeOfMotionGroupKeyPropertyEditable(s) && Enumerable.from(rangeOfMotionGroupIds).any(i => i === this.rangeOfMotionGroupEditor.toRangeOfMotionGroupId(s.rangeOfMotionGroupKey().getValue()))));
  }

  private async confirmScriptGroup(): Promise<boolean> {
    try {
      this.beginModal();
      const index = await this.$commonDialogs.confirmation.confirmYesNo(
        "オブジェクト削除確認",
        ["外部データオブジェクトが含まれています。同じ外部データオブジェクトはまとめて削除されます。本当に削除しますか？"]
      );
      return (index === 0);
    } catch {
      return false;
    } finally {
      this.endModal();
    }
  }
}
